import React from "react";
import "./LoadingComponent.css";

const LoadingComponent = () => {
  return (
    <div className="loading-container">
      <img
        src={require("../../Icons/riclogo.jpg")}
        alt="Loading..."
        className="blinking-image"
      />
    </div>
  );
};

export default LoadingComponent;
